import { APIMethod, fetchData } from "@client";

export async function removeProjectVersionCommentByPath(
  projectUuid,
  userUuid,
  versionKey,
  path
) {
  return await fetchData(
    "/v1/ws/project/comments/path",
    APIMethod.DELETE,
    {
      data: {
        uuid: projectUuid,
        user: userUuid,
        version: versionKey,
        path
      },
    }
  );
}